import { api } from "./api";

export const ondiApi = {
  config: async () => (await api.get("/ondi/config")).data,
  greeting: async () => (await api.get("/ondi/greeting")).data,
  chat: async (message, history) =>
    (await api.post("/ondi/chat", { message, history })).data,
  suggest: async (conversation_id) =>
    (await api.post("/ondi/suggest", { conversation_id })).data,
  inbox: async () => (await api.get("/ondi/inbox")).data,
  tourComplete: async () => (await api.post("/ondi/tour-complete")).data,
  tourReset: async () => (await api.post("/ondi/tour-reset")).data,
};
